(() => {
  if (window.KBCardColors) return;
  window.KBCardColors = true;
  const cards = new WeakMap();

  // Each selection gets fresh image nodes and listeners. An older decode cannot
  // expose an image, price, or back face from a superseded color.
  const watchMedia = card => {
    cards.get(card)?.abort();
    const controller = new AbortController();
    cards.set(card, controller);
    const link = card.querySelector('.kb-card__image');
    const media = card.querySelector('[data-kb-card-media]');
    const front = media?.querySelector('.kb-card__front');
    const back = media?.querySelector('.kb-card__back');
    const error = card.querySelector('[data-kb-card-media-error]');
    const status = card.querySelector('[data-kb-card-status]');
    if (!link || !front || !error || !status) return;
    let frontReady = false, backReady = false;
    link.classList.remove('kb-card__image--has-back', 'is-scroll-back');
    link.setAttribute('aria-busy', 'true');
    error.hidden = true;
    status.textContent = '';
    media.hidden = false;
    const current = () => !controller.signal.aborted && media.contains(front);
    const syncBack = () => link.classList.toggle('kb-card__image--has-back', frontReady && backReady);
    const settleFront = ok => {
      if (!current()) return;
      frontReady = ok;
      media.hidden = !ok;
      error.hidden = ok;
      link.removeAttribute('aria-busy');
      status.textContent = ok ? '' : error.textContent;
      syncBack();
    };
    const settleBack = ok => {
      if (!current()) return;
      backReady = ok;
      back.hidden = !ok;
      syncBack();
    };
    front.addEventListener('load', () => settleFront(true), { signal: controller.signal });
    front.addEventListener('error', () => settleFront(false), { signal: controller.signal });
    if (back) {
      back.addEventListener('load', () => settleBack(true), { signal: controller.signal });
      back.addEventListener('error', () => settleBack(false), { signal: controller.signal });
      if (back.complete) settleBack(back.naturalWidth > 0);
    }
    if (front.complete) settleFront(front.naturalWidth > 0);
  };

  const initialize = root => {
    const candidates = [...root.querySelectorAll('[data-kb-color-card]')];
    if (root.matches?.('[data-kb-color-card]')) candidates.unshift(root);
    for (const card of candidates) {
      if (cards.has(card)) continue;
      watchMedia(card);
      const controls = card.querySelector('[data-kb-card-colors]');
      if (controls) controls.hidden = false;
    }
  };

  document.addEventListener('click', event => {
    const button = event.target instanceof Element ? event.target.closest('button[data-kb-card-color]') : null;
    const card = button?.closest('[data-kb-color-card]');
    if (!card) return;
    const color = button.dataset.kbCardColor;
    const template = [...card.querySelectorAll('template[data-kb-card-color-template]')].find(item => item.dataset.kbCardColorTemplate === color);
    const media = card.querySelector('[data-kb-card-media]');
    const price = card.querySelector('[data-kb-card-price]');
    const compare = card.querySelector('[data-kb-card-compare]');
    if (!template || !media || !price || !compare) return;
    const failed = !card.querySelector('[data-kb-card-media-error]').hidden;
    if (card.dataset.color === color && !failed) return;
    cards.get(card)?.abort();
    card.dataset.color = color;
    media.replaceChildren(template.content.cloneNode(true));
    price.textContent = template.dataset.price;
    compare.textContent = template.dataset.compare || '';
    compare.hidden = !template.dataset.compare;
    for (const choice of card.querySelectorAll('button[data-kb-card-color]')) {
      choice.setAttribute('aria-pressed', String(choice === button));
    }
    watchMedia(card);
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const card of event.target.querySelectorAll('[data-kb-color-card]')) {
      cards.get(card)?.abort();
      cards.delete(card);
    }
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
})();
